import { render, staticRenderFns } from "./document-header.vue?vue&type=template&id=2bf871e0&scoped=true&"
import script from "./document-header.vue?vue&type=script&lang=js&"
export * from "./document-header.vue?vue&type=script&lang=js&"
import style0 from "./document-header.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf871e0",
  null
  
)

export default component.exports